import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

// Guard: Unregister service workers in preview/iframe contexts
const isInIframe = (() => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
})();

const isPreviewHost =
  window.location.hostname.includes("id-preview--") ||
  window.location.hostname.includes("lovableproject.com");

if (isPreviewHost || isInIframe) {
  navigator.serviceWorker?.getRegistrations().then((registrations) => {
    registrations.forEach((r) => r.unregister());
  });
}

// Capacitor: håndter deep links (åpne lenke i installert app)
// Når en bruker trykker på en lenke som https://forstesmak.lovable.app/accept-invitation?token=...
// fra f.eks. Messenger, vil Android åpne appen direkte (etter assetlinks.json + intent-filter
// er på plass — se ANDROID_DEEP_LINKS.md). Vi konverterer URL til intern path.
(async () => {
  try {
    const coreName = "@capacitor/core";
    const appName = "@capacitor/app";
    const cap: any = await import(/* @vite-ignore */ coreName).catch(() => null);
    if (!cap || !cap.Capacitor?.isNativePlatform?.()) return;
    const appMod: any = await import(/* @vite-ignore */ appName).catch(() => null);
    const CapApp = appMod?.App;
    if (!CapApp?.addListener) return;
    CapApp.addListener("appUrlOpen", (event: { url: string }) => {
      try {
        const url = new URL(event.url);
        const internalPath = url.pathname + url.search + url.hash;
        if (internalPath && internalPath !== window.location.pathname + window.location.search) {
          window.history.pushState({}, "", internalPath);
          window.dispatchEvent(new PopStateEvent("popstate"));
        }
      } catch (e) {
        console.warn("appUrlOpen parse error", e);
      }
    });
  } catch {
    // Capacitor ikke tilgjengelig — vi kjører på web
  }
})();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
